module.exports = __webpack_public_path__ + "img/gu.19249eb9.svg";